<script setup lang="ts">
/**
 * The application shell.
 *
 * Deliberately almost empty: it renders the current route and the one thing
 * that has to sit above every route, which is what stands in for the
 * application while there is no session. Everything else belongs to a view.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import SignInScreen from '@/components/shell/SignInScreen.vue'
import { useTextStyleSheet } from '@/features/typography/textStyleSheet'
import { useSessionStore } from '@/stores/session'

const session = useSessionStore()
const route = useRoute()

// The document's own named text styles, kept in a real stylesheet for as
// long as the application is open — see the composable for why.
useTextStyleSheet()

/**
 * The sign-in pages must render whatever the session says, since establishing
 * one is what they are for.
 */
const isAuthRoute = computed(
  () => route.name === 'sign-in-callback' || route.name === 'silent-renew',
)

const showGate = computed(() => !isAuthRoute.value && !session.isSignedIn)
</script>

<template>
  <div class="app-shell">
    <SignInScreen v-if="showGate" :establishing="session.establishing" :problem="session.problem" />
    <RouterView v-else />
  </div>
</template>

<style scoped>
.app-shell {
  min-height: 100vh;
  background: var(--color-bg);
  color: var(--color-text);
}
</style>
